<template>
    <VTextFieldFilled
        v-model="nmbr"
        :label="label"
        :rules="rules"
        class="number-input"
        type="text"
        :readonly="readonly"
        :hide-details="hideDetails"
        :placeholder="placeholder"
        :disabled="disabled"
        @update:model-value="change"
        :density="density"
    >
        <template #append-inner>
            <div class="d-flex flex-row">
                <!-- <span style="z-index: 1; font-size: small; height: fit-content; margin: auto;">mm</span> -->
                <div style="z-index: 1" class="d-flex flex-column justify-center mr-2">
                    <slot name="pre-append" />
                </div>
                <div class="caret-container">
                    <v-icon
                        icon="$fa-caret-up"
                        size="x-small"
                        @click.stop="increment()"
                        :class="{ 'cursor-pointer': !disabled }"
                    />
                    <v-icon
                        icon="$fa-caret-down"
                        size="x-small"
                        @click.stop="!readonly && decrement()"
                        :class="{ 'cursor-pointer': !disabled }"
                    />
                </div>
                <div style="z-index: 1" class="d-flex flex-column justify-center ml-2">
                    <slot name="post-append" />
                </div>
            </div>
        </template>
        <template v-if="$slots.append" #append>
            <slot name="append" />
        </template>
        <template v-if="$slots.prepend" #prepend>
            <slot name="prepend" />
        </template>
        <!-- <template #prepend-inner>
            <slot name="prepend-inner" />
        </template> -->
    </VTextFieldFilled>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

@Component({
    emits: ["change"],
})
export class CustomNumberField extends Vue {
    @Prop({ type: String, default: "" }) label;
    @Prop({ type: Array, default: () => [] }) rules;
    @Prop({ type: Number, default: 1 }) step;
    @Prop({ type: Number, default: undefined }) min;
    @Prop({ type: Number, default: undefined }) max;
    // @Prop({ type: String, default: "" }) variant: "" | "filled" | "underlined" | "outlined" | "plain" | "solo" | "solo-inverted" | "solo-filled"
    @Prop({ type: String, default: "compact" }) density: "default" | "compact" | "comfortable";
    @Prop({ type: Boolean, default: false }) readonly;
    @Prop({ type: Boolean, default: false }) hideDetails;
    @Prop({ type: [String, undefined], default: undefined }) placeholder;
    @Prop({ type: Boolean, default: false }) disabled;

    @Model({ type: [Number, String], default: "" }) nmbr;

    increment() {
        if (this.disabled) {
            return;
        }
        // debugger
        let val = this.nmbr ?? "";
        if (val === "") {
            val = 0;
        }
        if (typeof val !== "number") {
            try {
                val = Number(val);
            } catch (e) {
                debugger;
                throw e;
            }
        }
        // toFixed returns a string... cast to a number
        val = +Number((Number(this.nmbr) + Number(this.step)).toFixed(12));
        if (this.min != null && !isNaN(this.min)) {
            val = Math.max(this.min, val);
        }
        if (this.max != null && !isNaN(this.max)) {
            val = Math.min(this.max, val);
        }
        if (isNaN(val)) {
            val = 0;
        }

        this.nmbr = val;
    }

    decrement() {
        if (this.disabled) {
            return;
        }
        // debugger
        let val = this.nmbr ?? "";
        if (val === "") {
            val = 0;
        }
        if (typeof val !== "number") {
            try {
                val = Number(val);
            } catch (e) {
                debugger;
                throw e;
            }
        }
        // toFixed returns a string... cast to a number
        val = +Number((this.nmbr - Number(this.step)).toFixed(12));
        if (this.min != null && !isNaN(this.min)) {
            val = Math.max(this.min, val);
        }
        if (this.max != null && !isNaN(this.max)) {
            val = Math.min(this.max, val);
        }
        if (isNaN(val)) {
            val = 0;
        }
        this.nmbr = val;
    }

    @Watch("nmbr")
    change(val) {
        this.input(val);
        this.$emit("change", this.nmbr);
    }

    input(val) {
        if (val != null) {
            let newVal = val;
            if (this.min != null && !isNaN(this.min)) {
                newVal = Math.max(this.min, val);
            }
            if (this.max != null && !isNaN(this.max)) {
                newVal = Math.min(this.max, val);
            }
            if (isNaN(newVal)) {
                val = 0;
            }
            this.nmbr = newVal;
        }
    }
}

export default toNative(CustomNumberField);
</script>

<style scoped>
.number-input {
    position: relative;
}

.caret-container {
    display: flex;
    flex-direction: column;
}

/* .v-icon {
    cursor: pointer;
} */

.cursor-pointer {
    cursor: pointer;
}

:deep(.v-input__append-inner) {
    margin: auto !important;
}
</style>
